import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import Input from '../form/input';

import util from '../../lib/util';
import style from './style.css';

const initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false,
    },
};

@observer
class MailAddressList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};

        const { mailaddressStore } = this.props.stores;
        mailaddressStore.list();
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { mailaddressStore } = this.props.stores;
        const { totalAppend, limit } = mailaddressStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = mailaddressStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                mailaddressStore.updateOffset(offset);
                await mailaddressStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    async updateField(id, field, value) {
        const { mailaddressStore } = this.props.stores;
        mailaddressStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { mailaddressStore } = this.props.stores;
        await mailaddressStore.saveField(id, field, value);
    }

    render() {
        const { loading } = this.state;
        const { mailaddressStore } = this.props.stores;
        const { mailaddresses, queryFilter, saved } = mailaddressStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <small class='text-muted font-weight-lighter float-right mr-2'>
                            Total: {mailaddressStore.total}<br />
                        </small>

                        <span class='float-left form-row align-items-center mr-5'>
                            <div class='col-auto'>
                                <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for mail addresses...'
                                    onInput={e => mailaddressStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                                    value={queryFilter.search}
                                />
                            </div>
                            <div class='col-auto'>
                                <button type='button' class='btn btn-sm btn-primary' onClick={() => mailaddressStore.list()}>Search</button>
                            </div>
                        </span>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>

                        {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                            <h1><i class='fas fa-search' /> Search results</h1>
                            Found {mailaddressStore.total || 0} results in your search for "{queryFilter.search}".<br />
                            <button class='btn btn-sm btn-warning mt-2'
                                onClick={() => mailaddressStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                            >
                                <i class='fas fa-times' /> Reset search
                            </button>
                        </div>}

                        <div class='table-responsive'>
                            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                                <thead>
                                    {mailaddressStore.sort !== mailaddressStore.defaultSort && <tr>
                                        <th colspan='8'>
                                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => mailaddressStore.resetSort()}>
                                                <i class='fas fa-times-circle' /> Reset sort
                                            </span>
                                        </th>
                                    </tr>}
                                    <tr>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => mailaddressStore.toggleSort('email', '-')}>
                                                Email {util.getSortIcon('email', mailaddressStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>Bounce qty</th>
                                        <th style='width: 5%'>Complaint qty</th>
                                        <th style='width: 40%'>Bounces</th>
                                        <th style='width: 10%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => mailaddressStore.toggleSort('lastBounceDate', '-')}>
                                                Last bounce date {util.getSortIcon('lastBounceDate', mailaddressStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 20%'>Complaints</th>
                                        <th style='width: 10%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => mailaddressStore.toggleSort('updatedDate', '-')}>
                                                Updated {util.getSortIcon('updatedDate', mailaddressStore.sort)}
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {mailaddresses && mailaddresses.map(mailaddress => (
                                        <tr class={`${style.tableline}`}>
                                            <td>
                                                <a href={`/mailaddresses/${mailaddress.email}/Basics`}>{mailaddress.email}</a>
                                            </td>
                                            <td>
                                                {mailaddress.bounceQty}
                                            </td>
                                            <td>
                                                {mailaddress.complaintQty}
                                            </td>
                                            <td>
                                                {mailaddress.bounces && mailaddress.bounces.map(bounce => (
                                                    <div>
                                                        {bounce.bounceType} 
                                                        <small>
                                                            <div><span class='text-muted'>Date:</span> {util.ffeDateTime(bounce.timestamp)}</div>
                                                            <div><span class='text-muted'>Remote MTA IP:</span> {bounce.remoteMtaIp}</div>
                                                            <div><span class='text-muted'>Reporting MTA:</span> {bounce.reportingMTA}</div>
                                                            <div>
                                                                {bounce.bouncedRecipients.map(rcpt => (
                                                                    <div class='ml-4'>
                                                                        {rcpt.emailAddress}:
                                                                        {rcpt.action ? <div class='ml-4'><span class='text-muted'>Action:</span> {rcpt.action}</div> : <small><code>{JSON.stringify(mailaddress.bounces)}</code></small>}
                                                                        {rcpt.status && <div class='ml-4'><span class='text-muted'>Status:</span> {rcpt.status}</div>}
                                                                        {rcpt.diagnosticCode && <div class='ml-4 text-primary'><span class='text-muted'>Code:</span> {rcpt.diagnosticCode}</div>}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </small>
                                                    </div>
                                                ))}
                                            </td>
                                            <td class='text-right'>
                                                {util.ffeDateTime(mailaddress.lastBounceDate)}
                                            </td>
                                            <td>
                                                <small><code>{JSON.stringify(mailaddress.complaints)}</code></small>
                                            </td>
                                            <td class='text-right'>
                                                {util.ffeDateTime(mailaddress.updatedDate)}
                                            </td>
                                            <td class='text-right'>
                                                <span
                                                    class={`mr-1 badge ${style.pointerCursor} badge-danger`}
                                                    onClick={() => mailaddressStore.delete(mailaddress.email, 'email')}
                                                >
                                                    <i class={`fas fa-trash`} /> Delete
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default MailAddressList;




// WEBPACK FOOTER //
// ./components/mailaddresses/list.js